module.exports = __webpack_public_path__ + "media/images/icons/quotations-d0e206218113f16faceb4738538a72cc.svg";